import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewAssetStorageModalPage } from './view-asset-storage-modal.page';
import { OrderModule } from 'ngx-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';

const routes: Routes = [
  {
    path: '',
    component: ViewAssetStorageModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxPaginationModule,    
    OrderModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewAssetStorageModalPage]
})
export class ViewAssetStorageModalModule { }
